<app-header >
</app-header>
<div class="row">
  <div *ngIf="isForgotPassword || isMFA">
    <router-outlet *ngIf="detectBrowser">
      <span [class.loader-hidden]="!showLoader" class="loading-spinner"></span>
    </router-outlet>
    <div class="" *ngIf="!detectBrowser" style="padding: 100px;">
      <h3>YOUR BROWSER IS NOT SUPPORTED</h3>
      <h4>Internet Explorer is not supported</h4>
      <h4>The recommended browsers are: Chrome 70+, Firefox 90+, Safari 9+ and Edge 44+</h4>
    </div>
  </div>

  <div class="card csc-card" *ngIf="!isForgotPassword && !isMFA">
    <div class="card-inner card-inner-md" >
      <div class="container-fluid form-section content-padded">
        <router-outlet *ngIf="detectBrowser">
          <span [class.loader-hidden]="!showLoader" class="loading-spinner"></span>
        </router-outlet>
        <div class="" *ngIf="!detectBrowser" style="padding: 100px;">
          <h3>YOUR BROWSER IS NOT SUPPORTED</h3>
          <h4>Internet Explorer is not supported</h4>
          <h4>The recommended browsers are: Chrome 70+, Firefox 90+, Safari 9+ and Edge 44+</h4>
        </div>
      </div>
  </div>
</div>
</div>

<div class="footer-background">
        <app-footer *ngIf="!isLogin && !isForgotPassword && !isMFA && !isSSO && !isDOBCheck"></app-footer>
</div>
